import React from 'react';
// import './OrderTracker.css';
import '../Styles/TrackLine.css';

const steps = [
  { title: 'Pending', icon: '📦' },
  { title: 'Shipped', icon: '🚚' },
  { title: 'Arrived', icon: '🏠' }
];

const OrderTracker = ({ currentStep }) => {
  if (currentStep === 4) {
    return (
      <div className="order-tracker-container">
        <div className="order-tracker">
          <div className="step-container">
            <div className="step-content">
              <div className="step-circle active">
                <span className="step-icon">❌</span>
              </div>
              <div className="step-title active">Cancelled</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  if (currentStep === 3) {
    return (
      <div className="order-tracker-container">
        <div className="order-tracker">
          <div className="step-container">
            <div className="step-content">
              <div className="step-circle active">
                <span className="step-icon">✅</span>
              </div>
              <div className="step-title active">Delivered</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="order-tracker-container">
      <div className="order-tracker">
        {steps.map((step, index) => {
          const isActive = index <= currentStep;
          return (
            <div key={index} className="step-container">
              <div className="step-content">
                <div className={`step-circle ${isActive ? 'active' : ''}`}>
                  <span className="step-icon">{step.icon}</span>
                </div>
                <div className={`step-title ${isActive ? 'active' : ''}`}>
                  {step.title}
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className={`step-line ${index < currentStep ? 'active' : ''}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderTracker;
